import React from 'react';
import { compose } from 'recompose';
import pathEq from 'ramda/src/pathEq';
import Destinations from './Destinations';
import Home from './Home';
import About from './About';
import HeaderBar from './HeaderBar';
import { nonOptimalStates as branchOff } from './hocs/helpers';
import { Flex, Div } from './hocs/withStyles';
import illustrationSVG from '../svgs/illustration.svg';

const reroute = (hash = '') => {
  return () => {
    window.location.hash = hash;
    return null;
  };
};

const Routes = compose(
  branchOff([
    {
      when: pathEq(['route', 'name'], ''),
      render: Home
    },
    {
      when: pathEq(['route', 'name'], 'about'),
      render: About
    },
    {
      when: ({ route }) => route.name === 'from' && !route.params[0],
      render: reroute()
    },
    {
      when: pathEq(['route', 'name'], 'from'),
      render: Destinations
    }
  ])
)(reroute());

const Layout = compose()(props => {
  const { route, destinations } = props;
  const isHome = !route.name;
  const showBg = isHome || (!destinations && route.name !== 'about');
  return (
    <Div
      style={{
        backgroundColor: showBg ? '#00CEE8' : '',
        minHeight: '100vh'
      }}
    >
      {showBg && (
        <Div
          css={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            left: 0
          }}
        >
          <img src={illustrationSVG} alt="skylines" width="100%" />
        </Div>
      )}
      <Flex
        id="header"
        height="50px"
        justifyContent="space-between"
        width="100vw"
        css={{
          position: 'fixed',
          zIndex: 15,
          display: !destinations && route.name === 'from' ? 'none' : 'flex'
        }}
        onClick={() => {
          if (route.name === 'about') {
            window.location.hash = '';
          }
        }}
      >
        <HeaderBar {...props} />
      </Flex>
      <Flex
        maxWidth="1024px"
        m="0 auto"
        css={{
          position: isHome ? 'static' : 'relative',
          top: isHome ? '0px' : '50px'
        }}
      >
        <Routes {...props} />
      </Flex>
    </Div>
  );
});

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js